import { Divider, message, Space, Spin, Tag, Typography } from 'antd';
import { useEffect, useState } from 'react';
import { updateUserInfo } from 'services';

const AZInsightTab = ({ data }: any) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [tags, setTags] = useState<any>([]);

  const userId = data.user._id;

  const getHiddenMarketplace = () => {
    const hiddenMkps = data.user.hideMarketplace ? Object.keys(data.user.hideMarketplace).filter((mkp: string) => data.user.hideMarketplace[mkp]) : []
    setTags(() => {
      setLoading(false);
      return hiddenMkps;
    })
  }

  const handleOnDeleteTag = (tag: string) => {
    const hiddenMkps = tags.filter((mkp: string) => mkp !== tag);
    const params = {
      value: false,
      field: `hideMarketplace_${tag}`,
      id: userId
    };
    updateUserInfo(params)
      .then(() => {
        setTags(hiddenMkps);
        message.success('Removed hidden marketplace successfully');
      })
      .catch(() => {
        message.error('Removed hidden marketplace failed');
      })
      .finally(() => {
        setLoading(false);
      })
  };

  useEffect(() => {
    setLoading(true);
    getHiddenMarketplace()
  }, [])

  return (
    <Space direction="vertical" size="middle" style={{ width: "100%", padding: 20 }}>
      <Divider orientation="left">
        <Typography.Title level={3}>User AZInsight Settings</Typography.Title>
      </Divider>
      <Space direction="vertical">
        <Typography.Title level={5}>Hidden marketplace (main account):</Typography.Title>
        <Space>
          {loading ? (
            <div className="loading-page"><Spin size="small" /></div>
          ) : (
            tags.length > 0 ? tags.map((tag: string) => (
              <Tag key={tag} closable onClose={(e) => handleOnDeleteTag(tag)}>{tag}</Tag>
            )) : (
              <Typography.Text>No hidden marketplace</Typography.Text>
            )
          )}

        </Space>
      </Space>
    </Space>
  );
};

export default AZInsightTab;